import { authenticatedJsonRequest } from "services/api";
import { WHOLSTER_REST_BASE_URL } from "services/config";

export function recordPricingRequest(path, sessionId, options = {}) {
  return authenticatedJsonRequest(
    `${WHOLSTER_REST_BASE_URL}/recordPricing/${path}`,
    sessionId,
    options
  );
}

export const unwrapData = (response) => response?.data ?? response;
